














































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import TextBasic from '@/components/text/basic.vue';

@Component({
  props: ['detail', 'isTalk', 'isAnimation'],
})
export default class BoxVoiceFv extends Vue {}
